import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

function RoleRoute({ allow, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (allow && !allow.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export default RoleRoute;
